<template>

  <div class="stages-detail-page">
    <Header></Header>
    <section class="home-section-video">
      <!--padding:56.25% 0 0 0;-->
      <div style="padding:0 0 0 0;position:relative;">
        <iframe :src="backgroundVideo" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
      </div>
    </section>
    <section class="hero-section background-fit" :style="{ backgroundImage: `url(${imageUrl + videoCoverImage})` }">
      <div class="container">
        <div class="row">
          <div class="col-md-12 hero-col">

          </div>
        </div>
      </div>
    </section>
    <!--<section class="home-section-video" style="position: static;height: 100vh;">-->
      <!--<div class="stg-detail-i background-fit" v-if="!youtubeurl" :style="{ backgroundImage: `url(${imageUrl + videoCoverImage})` }"></div>-->
      <!--<iframe frameborder="0" height="100%" width="100%"-->
              <!--:src="`https://youtube.com/embed/`+youtubeurl+`?mute=1&autoplay=1&controls=0&showinfo=0&autohide=1`">-->
      <!--</iframe>-->
      <!--<iframe class="stg-detail-i" v-if="!youtubeF && youtubeurl" :src="`https://player.vimeo.com/video/`+youtubeurl+`?background=1&autoplay=1&loop=1&autopause=0&muted=1&controls=0&sidedock=0&title=0&byline=0&portrait=0`" width="640" height="360" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>-->
    <!--</section>-->
    <section class="stg-detail-section pt-5">
      <div class="container">
        <div class="row">
          <div class="col-md-9">
            <div class="stg-detail-blk pb-5">
              <router-link :to="`/artists/` + ownerId" class="stg-art-img background-fit" :style="{ backgroundImage: `url(${imageUrl + profileImage})` }"></router-link>
              <div class="stg-art-detail">
                <h3>{{title}}</h3>
                <p><span>By <router-link :to="`/artists/` + ownerId">{{name}}</router-link></span><span></span><span>{{created | formatDate}}</span></p>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <a href="javascript:void(0)" class="apply-to-stage" v-if="!applyStageFlag && logedIn && pastEvent" data-toggle="modal" data-target="#teamrolemodal">Apply to Stage</a>
            <span class="apply-to-stage" v-if="applyStageFlag && logedIn && pastEvent">Applied</span>
          </div>
        </div>
        <!--<div class="row">-->
          <!--<div class="col-md-12">-->
            <!--<div class="stg-detail-i background-fit" v-if="!youtubeurl" :style="{ backgroundImage: `url(${imageUrl + videoCoverImage})` }"></div>-->
            <!--<iframe class="stg-detail-i" style="width: 100%" v-if="youtubeF && youtubeurl" :src="`https://www.youtube.com/embed/`+youtubeurl" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
            <!--&lt;!&ndash;<div class="stg-detail-i background-fit" :style="{ backgroundImage: `url(${imageUrl + videoImage})` }"></div>&ndash;&gt;-->
            <!--<iframe class="stg-detail-i" style="width: 100%" v-if="!youtubeF && youtubeurl" :src="`https://player.vimeo.com/video/`+youtubeurl" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>-->
          <!--</div>-->
        <!--</div>-->
        <div class="row row-3 flex-column-reverse flex-sm-row">
          <div class="col-md-7 team-member-col">
            <div>
              <h3>Stage Description</h3>
              <p>
                {{description}}
              </p>
            </div>
            <div v-if="memebrs && memebrs.length">
              <h3>Team Members <a href="javascript:void(0)" v-if="showGroupChatBtn" class="group-chat-btn" v-on:click="groupChatFunction">Group Chat</a> </h3>
              <ul class="team-member-list">
                <li v-if="memebrs" v-for="(list, index) in memebrs" v-bind:key="index">
                  <div class="row">
                    <div class="col-md-8">
                      <div class="member-img background-fit" :style="{ backgroundImage: `url(${imageUrl + list.profiles[0].images[0].profileImageFile})` }"></div>
                      <div class="member-detail">
                        <h3><router-link :to="`/artists/`+list._id">{{list.name}}</router-link></h3>
                        <h4>{{list.role}} from {{list.profiles[0].location}}</h4>
                      </div>
                    </div>
                    <div class="col-md-4 text-right">
                      <span class="member-role">{{list.role}}</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-5 event-detail-col">
            <div v-if="tags && tags.length">
              <h3>Tags</h3>
              <p>
                <span class="tags" v-for="(list) in tags" v-bind:key="list.id">{{list}}<i>,</i> </span>
              </p>
            </div>
            <div v-if="roleList && roleList.length">
              <h3>Stage Roles</h3>
              <p>
                <span class="tags" v-if="roleList" v-for="(list, index) in roleList" v-bind:key="index">{{list.role}}<i>,</i> </span>
              </p>
            </div>
            <div v-if="eventLocation">
              <h3>Event Location</h3>
              <p>
                <span class="tags">{{eventLocation}}</span>
              </p>
            </div>
            <div v-if="tags && !tags.length">
              <h3>Event Date</h3>
              <p>
                <span class="tags">{{date | formatDate}}</span>
              </p>
            </div>
            <div v-if="rehersalSchedule">
              <h3>Rehersal Schedule</h3>
              <p>
                <span class="tags">{{rehersalSchedule}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Modal -->
    <div class="modal fade" id="teamrolemodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalCenterTitle">Add Team Members</h5>
          </div>
          <div class="modal-body">
            <div class="row team-role-heading">
              <div class="col-md-4">
                <h3>Role</h3>
              </div>
              <div class="col-md-4">
                <h3>Specialty</h3>
              </div>
              <div class="col-md-2">
                <h3>Remote</h3>
              </div>
              <div class="col-md-2">
                <h3>Select</h3>
              </div>
            </div>
            <div class="row role-choosed role-blk" style="margin: 0 -15px 15px;padding-bottom:10px;align-items: center;border-bottom: 1px solid #f2f2f2;" v-if="roleList" v-for="(list, index) in roleList" v-bind:key="index">
              <div class="col-md-4">
                <h4>{{list.role}}</h4>
              </div>
              <div class="col-md-4">
                <h4 v-if="list.specialty">{{list.specialty}}</h4>
                <h4 v-if="!list.specialty">-</h4>
              </div>
              <div class="col-md-2">
                <h4 v-if="list.remote">Remote</h4>
                <h4 v-if="!list.remote">Local</h4>
              </div>
              <div class="col-md-2">
                <label :for="`checkbox_`+index" v-on:click="activeFuntion"><img src="@/assets/img/check_mark.png" :data-id="list._id" width="30" /></label>
                <input class="checkbox-remote" type="radio" name="selectRole" :id="`checkbox_`+index" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" v-on:click="applyStageFunction">Apply</button>
          </div>
        </div>
      </div>
    </div>
    <section class="stages-section">
      <div class="container">
        <div class="row row-1">
          <div class="col-md-12">
            <h2>Recommended Stages</h2>
          </div>
        </div>
      </div>
    </section>
    <section class="stg-section">
      <div class="container">
        <div class="row row-2">
          <router-link :to="`/stage/` + stage._id" class="col-md-6 fc-col background-fit" v-for="(stage) in RecommendedStages" v-bind:key="stage.id" :style="{ backgroundImage: `url(${imageUrl + stage.videoId[0].videoImageFile})` }">
            <div class="inner-blk">
              <div class="i-blk">
                <div class="profile-p background-fit" :style="{ backgroundImage: `url(${imageUrl + stage.userId[0].profiles[0].images[0].profileImageFile})` }" v-if="stage.userId[0]"></div>
                <div class="p-detail">
                  <h3>{{stage.title}}</h3>
                  <p>{{stage.created | formatDate}}</p>
                  <!--<router-link :to="`/stage/` + stage._id"><span><img src="@/assets/img/next-arrow.svg"/></span></router-link>-->
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </section>
    <chat-stage-group v-if="showGroupChat" @updateChatStageGroupFunction="updateChatStageGroupFunction" :data="memebrs" :stageId="stageId" />
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './Header'
import Footer from './Footer'
import router from '../router'
import axios from 'axios'
import $ from "jquery"
import moment from 'moment'
import backgroundUrl from '@/assets/img/image6.jpg'
import backgroundUrl2 from '@/assets/img/image1.jpg'
import backgroundUrl1 from '@/assets/img/team/dasha.png'
import backgroundUrl4 from '@/assets/img/image4.jpg'
import backgroundUrl5 from '@/assets/img/image5.svg'
import backgroundUrl6 from '@/assets/img/image6.jpg'
import ChatStageGroup from "./include/ChatStageGroup";
export default {
  name: 'UpcomingStageDetail',
  components: {
      ChatStageGroup,
    'Header': Header,
    'Footer': Footer
  },
  mounted () {
      let windowWidth = $(window).width()
      let windowHeight = windowWidth*0.5625
      if(windowWidth < 667){
          windowHeight = '100vh'
          windowWidth = '177vh'
          $('.stages-detail-page .hero-section').height($(window).height())
      }
      $('.home-section-video iframe, .stages-detail-page .hero-section').css({
          height: windowHeight,
          width: windowWidth
      })

      var userData = localStorage.getItem('cbs_usertoken')
      if(userData) {
          userData = JSON.parse(userData)
          this.userId = userData.user.id
      }
      axios
          .get('/getStageById', {
              params: {
                  stageId: this.stageId
              }
          })
          .then(response => {
              console.log(response)
              let currentDate = moment(new Date()).format('YYYYMMDD')
              let eventDate = moment(response.data.date).format('YYYYMMDD')
              if(eventDate > currentDate){
                  this.pastEvent = true
              }
              this.title = response.data.title
              this.date = response.data.date
              this.created = response.data.created
              this.rehersalSchedule = response.data.rehersalSchedule
              this.name = response.data.userId[0].name
              this.profileImage = response.data.userId[0].profiles[0].images[0].profileImageFile
              if(response.data.videoId[0].videoImageFile){
                  this.videoCoverImage = response.data.videoId[0].videoImageFile
              }
              // this.videoCoverImage = response.data.videoId[0].videoImageFile
              // this.video = this.imageUrl + response.data.videoId[0].videourl
              this.description = response.data.description
              this.eventLocation = response.data.eventLocation
              if(response.data.tags && response.data.tags.length && Array.isArray(response.data.tags)){
                  this.tags = response.data.tags
              } else if(response.data.tags && response.data.tags.length) {
                  this.tags.push(response.data.tags)
              }
              this.ownerId = response.data.userId[0]._id
              var userData = localStorage.getItem('cbs_usertoken')
              if(userData){
                  userData = JSON.parse(userData)
                  this.logedIn = true
              } else {
                  this.logedIn = false
              }
              if(response.data.appliedArtist && userData){
                  if(response.data.appliedArtist.indexOf(userData.user.id) >= 0){
                      this.applyStageFlag = true
                  } else {
                      this.applyStageFlag = false
                  }
              }

              if(response.data.youtubeurl){
                  if(response.data.youtubeurl.includes('youtube')){
                      let uri = response.data.youtubeurl.split('?')
                      if (uri.length == 2)
                      {
                          let vars = uri[1].split('&')
                          let getVars = {}
                          let tmp = ''
                          vars.forEach(function(v){
                              tmp = v.split('=')
                              if(tmp.length == 2)
                                  getVars[tmp[0]] = tmp[1]
                          })
                          this.youtubeF = true
                          this.youtubeurl = getVars.v
                          // do

                          this.backgroundVideo = 'https://youtube.com/embed/'+this.youtubeurl+'?mute=1&autoplay=1&controls=0&showinfo=0&autohide=1'
                      }
                  } else if(response.data.youtubeurl.includes('vimeo')){
                      this.youtubeF = false
                      let uri = response.data.youtubeurl.split('/')
                      this.youtubeurl = uri[uri.length - 1]
                      this.backgroundVideo = '//player.vimeo.com/video/'+this.youtubeurl+'?api=1&background=1'
                  }
              }

          })
          .catch(error => console.log(error))

      axios
          .get('/getMembers', {
              params: {
                  stageId: this.stageId
              }
          })
          .then(response => {
              this.roleList = response.data
              let memebrs = []
              let $this = this
              $.each(response.data, function(key, value) {
                  if(value.appliedArtist.length){
                      $.each(value.appliedArtist, function(key1, value1) {
                          value1.role = value.role
                          memebrs.push(value1)
                          console.log('value1', value1._id)
                          console.log('$this.userId', $this.userId)
                          if(value1._id === $this.userId){
                              $this.showGroupChatBtn = true
                          }
                      })
                  }
              })
              this.memebrs = memebrs

          })
          .catch(error => console.log(error))

      axios
          .get('/getRecommendedStages', {
              params: {
                  stageId: this.stageId
              }
          })
          .then(response => {
              this.RecommendedStages = response.data
          })
          .catch(error => console.log(error))

  },
  data () {
    return {
        backgroundUrl: backgroundUrl,
        backgroundUrl1: backgroundUrl1,
        backgroundUrl2: backgroundUrl2,
        backgroundUrl4: backgroundUrl4,
        backgroundUrl5: backgroundUrl5,
        backgroundUrl6: backgroundUrl6,
        showGroupChat: false,
        showGroupChatBtn: false,
        youtubeF: true,
        youtubeurl: '',
        backgroundVideo: '',
        stageId: router.history.current.params.id,
        ownerId: '',
        created: '',
        roleId: '',
        roleList: '',
        memebrs: '',
        title: '',
        name: '',
        logedIn: false,
        pastEvent: false,
        date: '',
        videoImage: '',
        videoCoverImage: '',
        profileImage: '',
        description: '',
        eventLocation: '',
        rehersalSchedule: '',
        video: '',
        userId: '',
        applyStageFlag: false,
        tags: [],
        imageUrl: process.env.imageUrl,
        RecommendedStages: '',
        msg: 'Welcome to Your Vue.js App',
        playerOptions: ''
    }
  },
  computed: {

  },
  methods: {
      updateChatStageGroupFunction: function(event){
          this.showGroupChat = false
      },
      groupChatFunction: function(event){
          this.showGroupChat = true
      },
      activeFuntion: function(event){
          $('.checkbox-remote').closest('div').find('img').removeClass('active-checkbox')
          $(event.target).addClass('active-checkbox')
          this.roleId = event.target.dataset.id
      },
      applyStageFunction: function () {
          this.applyStageFlag = true
          var userData = localStorage.getItem('cbs_usertoken')
          if(userData){
              userData = JSON.parse(userData)
              try {
                  axios.post('/applyForStage', {
                      stageId: this.stageId,
                      artistId: userData.user.id,
                      ownerId: this.ownerId,
                      roleId: this.roleId
                  },{
                      headers: {
                          "content-type": "application/json",
                          "x-api-key": userData.token
                      }
                  }).then(res => {

                  }).catch(err => {

                      console.log(err)
                  })
              } catch (e) {
                  console.log(e)
              }
          }
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UpcomingStageDetail.vue